import type { SVGProps } from "react";
// generated from Check.svg — do not edit manually
// prettier-ignore
export default function Check(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 20 6 L 9 17 L 4 12" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
